import React, { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { Modal, Button, Form, Carousel } from "react-bootstrap";

const GET_PRODUCTOS_POR_CODIGO = gql`
  query GetProductosPorCodigo($codigos: [String!]!) {
    getProductosPorCodigo(codigos: $codigos) {
      _id
      nombre
      codigo
      precio
      stock
      imagen
    }
  }
`;

function GetProductos() {
  const { loading, error, data } = useQuery(GET_PRODUCTOS_POR_CODIGO, {
    variables: {
      codigos: [
        "7709043958707",
        "7709043958769",
        "7709043958776",
        "7709043958745",
        "7709043958721",
        "7709043958752",
        "7709043958783",
        "7709043958714",
      ],
    },
  });

  const [carrito, setCarrito] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);

  if (loading) return <p>Cargando productos...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const calcularPrecio = (producto) => {
    const precioBase = parseFloat(producto.precio) || 0;
    if (producto.codigo === "1") {
      return precioBase * 1000 + 200;
    }
    return precioBase;
  };

  const agregarAlCarrito = (producto) => {
    const precioFinal = calcularPrecio(producto);
    const cantidadInicial = producto.codigo === "1" ? 1000 : 1;
    const itemExistente = carrito.find((p) => p._id === producto._id);

    if (itemExistente) {
      setCarrito((prev) =>
        prev.map((p) =>
          p._id === producto._id
            ? { ...p, cantidad: p.cantidad + cantidadInicial }
            : p
        )
      );
    } else {
      const item = {
        ...producto,
        precioVenta: precioFinal,
        cantidad: cantidadInicial,
      };
      setCarrito((prev) => [...prev, item]);
    }
  };

  const actualizarCantidad = (id, nuevaCantidad) => {
    setCarrito((prev) =>
      prev.map((p) =>
        p._id === id
          ? {
              ...p,
              cantidad: Number(nuevaCantidad) > 0 ? Number(nuevaCantidad) : 1,
            }
          : p
      )
    );
  };

  const eliminarProducto = (id) => {
    setCarrito((prev) => prev.filter((p) => p._id !== id));
  };

  const total = carrito.reduce((acc, p) => acc + p.precioVenta * p.cantidad, 0);

  const finalizarVenta = () => {
    if (carrito.length === 0) return alert("El carrito está vacío");

    const textoProductos = carrito
      .map(
        (p, i) =>
          `${i + 1}. ${p.nombre} — Cant: ${p.cantidad} — $${(
            p.precioVenta * p.cantidad
          ).toLocaleString()}`
      )
      .join("\n");

    const mensaje = `🛒 *Pedido Campo Fruver*\n\n${textoProductos}\n\nTotal: *$${total.toLocaleString()}*`;

    const numero = "573226140539";
    const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank");
    setCarrito([]);
  };

  return (
    <div className="container mt-4">
      {/* 🌈 Carrusel de imágenes de portada */}
      <Carousel className="mb-4" fade controls indicators interval={4000}>
        <Carousel.Item>
          <img
            className="d-block w-100 rounded"
            src="https://www.numanzia.com/wp-content/uploads/2024/07/descubre-los-sorprendentes-beneficios-de-las-moras-para-tu-salud-800x500.jpg"
            alt="Pulpas variadas"
            style={{ height: "250px", objectFit: "cover", objectPosition: "center" }}
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 rounded"
            src="https://tse2.mm.bing.net/th/id/OIP.0YmQZjD2YAZgpXKYAtfZbwHaEK?pid=Api&P=0&h=180"
            alt="Frutas tropicales"
            style={{ height: "250px", objectFit: "cover", objectPosition: "center" }}
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 rounded"
            src="https://agroproductores.com/wp-content/uploads/2021/06/pina-1.jpg"
            alt="Pulpa natural"
            style={{ height: "250px", objectFit: "cover", objectPosition: "center" }}
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 rounded"
            src="https://vida-sustentable.com/wp-content/uploads/2023/11/guia-practica-para-el-cultivo-de-guanabana-consejos-y-tecnicas-efectivas.jpg"
            alt="Pulpa natural"
            style={{ height: "250px", objectFit: "cover", objectPosition: "center" }}
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 rounded"
            src="https://cdn.portalfruticola.com/2022/11/media-works-10-1024x663.png"
            alt="Pulpa natural"
            style={{ height: "250px", objectFit: "cover", objectPosition: "center" }}
          />
        </Carousel.Item>
      </Carousel>



      <div className="row">
        {data.getProductosPorCodigo.map((producto) => {
          const precioAjustado = calcularPrecio(producto);
          return (
            <div key={producto._id} className="col-md-3 col-sm-6 mb-4">
              <div className="card p-3 shadow-sm text-center h-100">
                {producto.imagen ? (
                  <img
                    src={producto.imagen}
                    alt={producto.nombre}
                    className="card-img-top mb-2"
                    style={{ height: "160px", objectFit: "cover" }}
                  />
                ) : (
                  <div
                    className="bg-light d-flex align-items-center justify-content-center mb-2"
                    style={{ height: "160px" }}
                  >
                    <span className="text-muted">Sin imagen</span>
                  </div>
                )}
                <h5>{producto.nombre}</h5>
                <p className="text-success fw-bold">
                  ${Number(precioAjustado).toLocaleString()}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* 🛒 Carrito */}
      {carrito.length > 0 && (
        <div className="mt-4 border rounded p-3 bg-light">
          <h5>🛒 Carrito ({carrito.length})</h5>
          <ul className="list-unstyled">
            {carrito.map((p) => (
              <li
                key={p._id}
                className="d-flex align-items-center justify-content-between mb-2"
              >
                <div>
                  <strong>{p.nombre}</strong> — ${p.precioVenta.toLocaleString()}
                </div>
                <div className="d-flex align-items-center">
                  <Form.Control
                    type="number"
                    min="1"
                    value={p.cantidad}
                    onChange={(e) => actualizarCantidad(p._id, e.target.value)}
                    style={{ width: "70px", marginRight: "10px" }}
                  />
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => eliminarProducto(p._id)}
                  >
                    🗑️
                  </Button>
                </div>
              </li>
            ))}
          </ul>
          <h6 className="text-end">
            Total: <strong>${total.toLocaleString(0)}</strong>
          </h6>
          <Button variant="primary" onClick={finalizarVenta}>
            Finalizar venta y enviar por WhatsApp
          </Button>
        </div>
      )}

      {/* 💬 Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/573226140639"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "30px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
          zIndex: 1000,
          textDecoration: "none",
        }}
      >
        <img src="https://logospng.org/download/whatsapp/logo-whatsapp-4096.png" width='100px' height='100px' alt="" />
      </a>
    </div>
  );
}

export default GetProductos;
